import React from "react";
import { Modal } from "react-bootstrap";
import { Plus, X, Settings } from "lucide-react";

const StoppageModal = ({
  show,
  onHide,
  stoppageEntries,
  selectedStoppageRows,
  setSelectedStoppageRows,
  handleAddStoppageRow,
  handleDeleteSelectedStoppages,
  handleUpdateStoppageField,
  handleSaveStoppageDetails,
  toMachineVal,
  stoppageReasons,
  themeColors
}) => {
  
  const {
    iscolour,
    iscolourDark,
    isdark,
    btnBg,
    accentCol,
    btnText
  } = themeColors;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      backdrop="static"
      dialogClassName="custom-xl-modal"
      contentClassName="sd-modal-content"
    >
      <style>{`
        /* ── Stoppage Detail Modal ── */
        .sd-modal-content {
          background: ${isdark === "light" ? iscolour?.Colour1 || "#fff" : iscolourDark?.Colour10 || "#1a1208"} !important;
          border: 2px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"} !important;
          border-radius: 16px !important;
          overflow: hidden;
          box-shadow: 0 35px 80px rgba(0,0,0,0.5) !important;
        }
        .sd-header {
          background: linear-gradient(135deg,
            ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} 0%,
            ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour7 || "#7a5637"} 100%
          );
          padding: 16px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .sd-header-title {
          font-size: 16px;
          font-weight: 800;
          color: #fff;
          letter-spacing: 0.5px;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .sd-header-icon {
          width: 36px; height: 36px;
          border-radius: 10px;
          background: rgba(255,255,255,0.22);
          display: flex; align-items: center; justify-content: center;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }
        .sd-action-bar {
          background: ${isdark === "light" ? iscolour?.Colour3 || "#faf8f5" : iscolourDark?.Colour9 || "#2d1f0f"};
          padding: 14px 24px;
          border-bottom: 1.5px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"};
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          flex-wrap: wrap;
        }
        .sd-tbl {
          width: 100%;
          border-collapse: collapse;
        }
        .sd-tbl thead th {
          background: ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour7 || "#7a5637"} !important;
          color: #fff !important;
          font-size: 12px !important;
          font-weight: 800 !important;
          padding: 12px 16px !important;
          border-right: 1px solid ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} !important;
          border-bottom: 2px solid ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} !important;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          position: sticky;
          top: 0;
          z-index: 2;
        }
        .sd-tbl thead th:last-child { border-right: none !important; }
        .sd-tbl tbody td {
          font-size: 13.5px !important;
          padding: 10px 16px !important;
          border-right: 1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour8 || "#6b4423"} !important;
          border-bottom: 1px solid ${isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour8 || "#6b4423"} !important;
          color: ${isdark === "light" ? iscolour?.Colour11 || "#8b5a2b" : iscolourDark?.Colour1 || "#fcefd9"} !important;
          vertical-align: middle !important;
        }
        .sd-tbl tbody td:last-child { border-right: none !important; }
        .sd-tbl tbody tr:nth-child(odd) td {
          background: ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour9 || "#2d1f0f"} !important;
        }
        .sd-tbl tbody tr:nth-child(even) td {
          background: ${isdark === "light" ? iscolour?.Colour1 || "#fff" : iscolourDark?.Colour10 || "#1a1208"} !important;
        }
        .sd-tbl tbody tr:hover td {
          background: ${isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour7 || "#7a5637"} !important;
        }
        .sd-input-field {
          background: ${isdark === "light" ? iscolour?.Colour1 || "#fff" : iscolourDark?.Colour10 || "#1a1208"} !important;
          border: 1.5px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"} !important;
          color: ${isdark === "light" ? iscolour?.Colour11 || "#8b5a2b" : iscolourDark?.Colour1 || "#fcefd9"} !important;
          border-radius: 8px;
          padding: 6px 12px;
          font-size: 13.5px;
          font-weight: 700;
          outline: none;
          width: 100%;
          transition: all 0.2s ease;
        }
        .sd-input-field:focus {
          border-color: ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f"} !important;
          box-shadow: 0 0 0 3px ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f"}33;
        }
        .sd-footer {
          background: ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"};
          padding: 14px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          flex-wrap: wrap;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }
        .sd-table-wrap {
          overflow-y: auto; max-height: 380px;
          overflow-x: auto;
        }
        .sd-table-wrap::-webkit-scrollbar { width: 5px; height: 5px; }
        .sd-table-wrap::-webkit-scrollbar-track {
          background: ${isdark === "light" ? iscolour?.Colour3 || "#faf8f5" : iscolourDark?.Colour10 || "#1a1208"};
        }
        .sd-table-wrap::-webkit-scrollbar-thumb {
          background: ${isdark === "light" ? iscolour?.Colour7 || "#d7b08a" : iscolourDark?.Colour6 || "#8b5a2b"};
          border-radius: 4px;
        }
        .sd-badge-txn {
          background: ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"};
          color: #fff;
          padding: 6px 16px;
          border-radius: 20px;
          font-weight: 800;
          font-size: 13px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }
      `}</style>

      {/* HEADER */}
      <div className="sd-header">
        <div className="sd-header-title">
          <div className="sd-header-icon">
            <Settings size={18} color="#fff" />
          </div>
          Stoppage Logs Detail
        </div>
        <button className="td-close-btn" onClick={onHide}>
          <X size={16} />
        </button>
      </div>

      {/* ACTION BAR */}
      <div className="sd-action-bar">
        <div className="sd-badge-txn">
          Transaction Mode : &nbsp;<span style={{ color: isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour2 || "#f5c99f" }}>{toMachineVal || "JIGGER"}</span>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={handleAddStoppageRow}
            style={{
              background: `linear-gradient(135deg, ${btnBg} 0%, ${accentCol} 100%)`,
              color: btnText,
              border: "none",
              borderRadius: "8px",
              padding: "6px 16px",
              fontWeight: "700",
              fontSize: "12.5px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              boxShadow: `0 4px 12px ${btnBg}30`
            }}
            className="hover-scale-btn"
          >
            <Plus size={14} /> Add Stoppage
          </button>
          <button
            onClick={handleDeleteSelectedStoppages}
            style={{
              background: "#dc2626",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              padding: "6px 16px",
              fontWeight: "700",
              fontSize: "12.5px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              boxShadow: "0 4px 12px rgba(220, 38, 38, 0.3)"
            }}
            className="hover-scale-btn"
          >
            <X size={14} /> Delete Selected
          </button>
        </div>
      </div>

      {/* TABLE BODY */}
      <div className="sd-table-wrap">
        <table className="sd-tbl">
          <thead>
            <tr>
              <th style={{ width: "50px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  style={{ accentColor: btnBg, width: "15px", height: "15px" }}
                  onChange={(e) => {
                    const all = {};
                    if (e.target.checked) stoppageEntries.forEach(r => { all[r.id] = true; });
                    setSelectedStoppageRows(all);
                  }}
                />
              </th>
              <th>Start Time (24 Hours)</th>
              <th>End Time (24 Hours)</th>
              <th style={{ width: "130px", textAlign: "center" }}>Diff</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {stoppageEntries.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center py-5 text-secondary" style={{ fontStyle: "italic", fontSize: "14px" }}>
                  No stoppage records found. Click "Add Stoppage" above to log downtime.
                </td>
              </tr>
            ) : (
              stoppageEntries.map((entry) => (
                <tr key={entry.id} className={selectedStoppageRows[entry.id] ? "td-selected-row" : ""}>
                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={!!selectedStoppageRows[entry.id]}
                      onChange={(e) => {
                        setSelectedStoppageRows(prev => ({
                          ...prev,
                          [entry.id]: e.target.checked
                        }));
                      }}
                      style={{ accentColor: btnBg, width: "15px", height: "15px" }}
                    />
                  </td>
                  <td>
                    <input
                      type="datetime-local"
                      value={entry.startTime}
                      onChange={(e) => handleUpdateStoppageField(entry.id, "startTime", e.target.value)}
                      className="sd-input-field"
                    />
                  </td>
                  <td>
                    <input
                      type="datetime-local"
                      value={entry.endTime}
                      onChange={(e) => handleUpdateStoppageField(entry.id, "endTime", e.target.value)}
                      className="sd-input-field"
                    />
                  </td>
                  <td style={{ textAlign: "center", fontWeight: "800", color: "#ef4444" }}>
                    {entry.diff || "—"}
                  </td>
                  <td>
                    <select
                      value={entry.reason}
                      onChange={(e) => handleUpdateStoppageField(entry.id, "reason", e.target.value)}
                      className="sd-input-field"
                      style={{ cursor: "pointer" }}
                    >
                      <option value="" style={{ background: isdark === "light" ? "#fff" : "#1a1208", color: isdark === "light" ? "#000" : "#fff" }}>-- Select Reason --</option>
                      {stoppageReasons.map(r => (
                        <option key={r.id} value={r.value} style={{ background: isdark === "light" ? "#fff" : "#1a1208", color: isdark === "light" ? "#000" : "#fff" }}>
                          {r.label}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* FOOTER */}
      <div className="sd-footer">
        <div style={{ display: "flex", gap: "10px" }}>
          <button className="td-btn td-btn-ok"
            onClick={handleSaveStoppageDetails}>
            ✔ OK
          </button>
          <button className="td-btn td-btn-cancel"
            onClick={onHide}>
            <X size={13} /> Cancel
          </button>
        </div>
        
        <div style={{ fontSize: "14px", fontWeight: "800", color: "#fff" }}>
          Total Downtime Duration : &nbsp;
          <span style={{ color: isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour2 || "#f5c99f" }}>
            {stoppageEntries.reduce((acc, entry) => {
              if (!entry.startTime || !entry.endTime) return acc;
              const ms = new Date(entry.endTime) - new Date(entry.startTime);
              return ms > 0 ? acc + Math.floor(ms / 60000) : acc;
            }, 0)} mins
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default StoppageModal;
